import { useMutation } from '@tanstack/react-query';
import type { AddressMismatchReport } from '../lib/addressMismatchRow';
import type { AddressMismatchOutcome } from '../model/addressMismatchFlow';

// The «Notificar mismatch» WRITE: one row appended to the Google Sheet shared with Amazon. The send
// is injected by the host, which owns the Google token and the Sheets call. retry: false — the row
// lands outside Citibox and cannot be taken back, so a silent re-send is a duplicate report.
//
// **No invalidateQueries, and that is not an omission.** Every other write in the panel refreshes
// the reads it made stale; this one's destination is not a panel read, so there is no cache to
// refresh (the «already reported» answer is SET by the caller from the outcome, not refetched). Do
// not copy this hook as the pattern for a write over a panel entity.
export function useReportAddressMismatch(
  send: (report: AddressMismatchReport) => Promise<AddressMismatchOutcome>,
) {
  return useMutation({
    mutationFn: (report: AddressMismatchReport) => send(report),
    retry: false,
  });
}
